import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
import {ObjectSchema} from 'yup';


import {CaptchaForm, Form} from '../../../../services/FormService';


function ValidatingForm({children, data, errors, id, isCaptcha, onIsInvalid, onIsValid, validationSchema}) {

    const [formData, setFormData] = useState(() => data);

    const [form, setForm] = useState(null);

    useEffect(() => {

        const form = isCaptcha
            ? new CaptchaForm(id, validationSchema, formData)
            : new Form(id, validationSchema, formData);
        form.onChangeHook = function () {

            // setting into a new object to
            const updatedFormData = form.getData();
            setFormData(updatedFormData);

            const formData = form.getData();

            if (form.isValid() && onIsValid) {
                onIsValid(formData);
            }

            if (!form.isValid() && onIsInvalid) {
                onIsInvalid(formData);
            }
        };
        form.onChangeHook = form.onChangeHook.bind(this);

        setForm(form);

    }, []);

    if (!form) {

        return null;
    }

    return (
        <>
            {children({form})}
        </>
    );
}


ValidatingForm.propTypes = {
    children: PropTypes.func.isRequired,
    data: PropTypes.oneOfType(
        [
            PropTypes.array,
            PropTypes.object
        ]
    ),
    errors: PropTypes.object,
    id: PropTypes.string,
    isCaptcha: PropTypes.bool,
    onIsInvalid: PropTypes.func,
    onIsValid: PropTypes.func,
    validationSchema: PropTypes.instanceOf(ObjectSchema).isRequired
};

ValidatingForm.defaultProps = {
    data: {},
    errors: {},
    isCaptcha: false
};


export default ValidatingForm;
